import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/block/basco.png")